<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const loading = ref(false)

const blockContent = computed(() => props.data.content)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})
</script>

<template>
  <!--<ul
    class="flex bg-[#dcd6ce] text-[#363330] text-[0.8rem] italic lg:text-lg justify-center gap-6 px-4 pb-14"
  >
    <li
      v-for="(item, index) in blockContent.items"
      :key="index"
      class="pb-2 flex justify-center flex-col"
    >
      <div class="text-center mb-2">
        <i class="!block text-[3rem]" :class="item.icon"/>
      </div>
      <span class="flex flex-nowrap">{{ item.title }}</span>
    </li>
  </ul>-->
  <div
    class="grid grid-cols-12 bg-[#dcd6ce] text-[#363330] text-[0.8rem] italic lg:text-lg text-center gap-4 px-4 pb-14"
    id="icon-pi"
    :class="containerClasses"
  >
    <div
      v-for="(item, index) in blockContent.items"
      :key="index"
      class="col-span-6 lg:col-span-2 pb-2"
    >
      <div class="text-center mb-2">
        <i class="!block text-[3rem]" :class="item.icon"/>
      </div>
      <span class="">{{ item.title }}</span>
    </div>
  </div>
</template>
